module.exports = require("highlight.js/styles/atom-one-dark.css");